import { API } from "@/lib/api";

const WhatsAppGlyph = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.08-.3-.15-1.13-.42-2.15-1.33-.8-.71-1.33-1.59-1.49-1.89-.15-.3-.02-.46.13-.61.15-.15.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.08-.79.38-.27.3-1.03 1.01-1.03 2.46s1.06 2.86 1.21 3.06c.15.2 2.08 3.18 5.04 4.46.7.3 1.25.48 1.68.62.71.22 1.35.19 1.86.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35zM12.04 21.5h-.01c-1.77 0-3.5-.48-5.02-1.37l-.36-.21-3.73.98 1-3.64-.23-.37A9.86 9.86 0 0 1 2.2 11.9c0-5.46 4.44-9.9 9.9-9.9 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 0 1 2.9 6.99c0 5.46-4.44 9.9-9.95 9.9zM20.52 3.4A11.78 11.78 0 0 0 12.13 0C5.6 0 .29 5.31.28 11.84c0 2.08.54 4.11 1.58 5.9L0 24l6.4-1.68a11.85 11.85 0 0 0 5.72 1.46h.01c6.53 0 11.84-5.31 11.85-11.84 0-3.17-1.23-6.14-3.46-8.38z" />
  </svg>
);

const XGlyph = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M18.9 1.5h3.68l-8.04 9.19L24 22.5h-7.4l-5.8-7.58-6.63 7.58H.49l8.6-9.83L0 1.5h7.59l5.44 7.2L18.9 1.5zm-1.3 18.78h2.04L6.48 3.61H4.3l13.3 16.67z" />
  </svg>
);

// Shared links point at the backend preview route so WhatsApp/X can read the
// Open Graph card; it redirects real visitors to the article instantly.
export const shareLink = (id) => `${API}/s/${id}`;

const waUrl = (article) => {
  const text = `*${article.title}*\n\n${article.summary || ""}\n\n${shareLink(article.id)}\n\n— Khabrik News`;
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
};

const xUrl = (article) =>
  `https://twitter.com/intent/tweet?text=${encodeURIComponent(article.title)}&url=${encodeURIComponent(
    shareLink(article.id)
  )}`;

export const WhatsAppShareButton = ({ article }) => (
  <a
    href={waUrl(article)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-share-button"
    className="flex items-center gap-1.5 text-[#25D366] hover:text-[#1FBE5A] transition-colors"
  >
    <WhatsAppGlyph size={14} /> व्हाट्सऐप
  </a>
);

export const XShareButton = ({ article }) => (
  <a
    href={xUrl(article)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="x-share-button"
    className="flex items-center gap-1.5 text-white hover:text-[#FFD400] transition-colors"
  >
    <XGlyph size={13} /> एक्स
  </a>
);

export const WhatsAppShareIcon = ({ article }) => (
  <button
    type="button"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      window.open(waUrl(article), "_blank", "noopener,noreferrer");
    }}
    aria-label="व्हाट्सऐप पर शेयर करें"
    data-testid={`whatsapp-share-${article.id}`}
    className="flex items-center justify-center w-8 h-8 rounded-full bg-[#0D0D10]/80 backdrop-blur text-[#25D366] border border-white/10 hover:bg-[#25D366] hover:text-white transition-colors"
  >
    <WhatsAppGlyph size={13} />
  </button>
);
